import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	CORRESPONDENCE_FUNCTION_FEATURE_KEY,
	CorrespondenceFunctionState,
	CorrespondenceFunctionPartialState,
	correspondenceFunctionAdapter
} from './function.reducer';

// Lookup the 'CorrespondenceFunction' feature state managed by NgRx
export const getCorrespondenceFunctionState = createFeatureSelector<
	CorrespondenceFunctionPartialState,
	CorrespondenceFunctionState
>(CORRESPONDENCE_FUNCTION_FEATURE_KEY);

const { selectAll, selectEntities } = correspondenceFunctionAdapter.getSelectors();

export const getCorrespondenceFunctionLoaded = createSelector(
	getCorrespondenceFunctionState,
	(state: CorrespondenceFunctionState) => state.loaded
);

export const getCorrespondenceFunctionError = createSelector(
	getCorrespondenceFunctionState,
	(state: CorrespondenceFunctionState) => state.error
);

export const loadingCorrespondenceFunction = createSelector(
	getCorrespondenceFunctionState,
	(state: CorrespondenceFunctionState) => state.loaded
);

export const getAllCorrespondenceFunction = createSelector(
	getCorrespondenceFunctionState,
	(state: CorrespondenceFunctionState) => selectAll(state)
);

export const getCorrespondenceFunctionEntities = createSelector(
	getCorrespondenceFunctionState,
	(state: CorrespondenceFunctionState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getCorrespondenceFunctionState,
	(state: CorrespondenceFunctionState) => state.selectedCorrespondenceFunctionId
);

export const getSelected = createSelector(
	getCorrespondenceFunctionEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
